<template>
  <DBox :id="'cmp-api-configs'" @add_click="onAddItemClick">
    <div class="api-form-items">
      <div v-for="apiForm of apiForms" :key="apiForm.form_name" class="api-item">
        <div class="api-title">{{apiForm.form_name}}</div>
        <div class="api-form" v-for="(fd, index) of apiForm.formData" :key="index">
          <div class="api-form--options">
            <img
              src="static/icons/delete.svg"
              class="dt-icon v5 s1"
              @click="e => onDeleteItem({form_name: apiForm.form_name, item: fd})"
              :alt="$t('delete_item')"
              :title="$t('delete_item')"
            />
          </div>
          <DynamicForm
            :forms="apiForm.form"
            :formsData="fd"
            :textFieldConfig="textFieldConfig"
            @changed="({name, value}) => onDynamicFormChange({name, value, form_name: apiForm.form_name, index})"
            @validated="({name, value}) => onDNValidated({name, value, form_name: apiForm.form_name, index})"
          />
        </div>
      </div>
    </div>
    <!-- <div class="save-button-container">
      <button class="dt-button v1 s6" @click.stop="onSave">{{$t('save')}}</button>
    </div>-->
  </DBox>
</template>

<script>
import DynamicForm from "@plugins/form-builder/dynamic-form";
import DBox from "@dtplugins/dbox/dbox";
import ModalContainer from "@dtplugins/modal/modal-container";
import { EventHooks } from "../../../../plugins/text-field";
import { createForm } from "../../../../plugins/form-builder/form.model";
import { showError, showNotification } from '../../../../dt-plugins/notification/notification.service';
import { set, lensPath, fromPairs, toPairs } from 'ramda';

export default {
  components: {
    DynamicForm,
    DBox,
    ModalContainer,
  },
  props: ["labelSettingsData"],
  mounted: function() {
    console.log(this);
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },
      formData: null
    };
  },
  watch: {
    labelSettingsData: {
      immediate: true,
      handler: function(newValue, oldValue) {
        this.formData = newValue;
      }
    }
  },
  computed: {
    formsData: function() {
      return {};
    },
    apiForms: function() {
      return Object.keys(this.labelSettingsData?.translator_api_configs_structure || {}).map(e => {
        return {
          form_name: e,
          form: this.labelSettingsData?.translator_api_configs_structure?.[e]?.map(e => {
            return createForm({
              name: e.name,
              required: e.required == 'required' ? true : false,
              field_name: e.field_name,
              showValidationIcons: e.required == 'required' ? true : false,
            });
          }),
          formData: this.labelSettingsData.translator_api_configs?.[e]
        };
      });
    }
  }, 
  methods: {
    onDynamicFormChange: function(payload) {
      if (!this.isFormValid()) {
        showError('Provide all the mandatory Fields');
      } else {
        this.$emit("changed", payload);
        showNotification('API Config Updated');
      }
    },
    onDropdownChange: function(name, value) {},
    onSave: function() {},
    onAddItemClick: function() {
      this.$emit('add_click', true);
    },
    onDNValidated: function({name, value, form_name, index}) {
      this.formValidation = set(lensPath([form_name, index, name]), value, this.formValidation);
    },
    isFormValid: function() {
      const temp2 = this.formValidation;
      const flatValidationObj = fromPairs(toPairs(temp2).map(([f, v1]) => toPairs(v1).map(([i, v2]) => toPairs(v2).map(([n, v3]) => [`${f}_${i}_${n}`, v3]))).flat(2));
      return Object.keys(flatValidationObj)
        .map(key => flatValidationObj[key].valid)
        .every(e => e);
    },
    onDeleteItem: function(payload) {
      this.$emit('deleted', payload);
    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-api-configs {
  display: flex;
  flex-direction: column;
  .api-form-items {
    flex: 5;
    overflow: auto;
    .api-item {
      .api-title {
        padding: 5px 6px;
        text-align: center;
        text-transform: capitalize;
        font-weight: 500;
        background: var(--bc-3);
      }
      .api-form {
        padding: 5px 0px 10px 0px;
        border-bottom: 1px solid var(--sprt-8);
        .api-form--options {
          display: flex;
          justify-content: flex-end;
          padding-top: 2px;
        }
        .form-group {
          padding-right: 26px;
        }
        // &:nth-child(2n+1) {
        //   background: var(--bc-3);
        // }
      }
    }
  }
  .save-button-container {
    border-top: 1px solid var(--sprt-8);
    flex: 0.5;
    min-height: 40px;
    max-height: 40px;
    padding: 5px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
